import { useEffect, useState, memo, useMemo, useRef } from "react";
import { SchedulerProviderArray } from "../../../actions/SchedulerActions";
import { useDispatch, useSelector } from "react-redux";
import ProviderSchedModal from "../../Setup/Account/Provider/ProviderSchedModal";

const SearchList = ({ view, caseType, type, ItemLists, getProvider, handleSelectedProviders, Name, AllLocation, handleSelectedProvidersLocation, AddCounty, ConfirmDelete, className, providerViewMode }) => {
  const dispatch = useDispatch();
  let IsHomeCare = useSelector(state => state?.GeneralDropDownsReducer?.IsHomeCare)

  const [searchQuery, setSearchQuery] = useState("");
  const viewInitializedRef = useRef(false);
  const prevViewRef = useRef(view);
  const [selectedItemsLocation, setSelectedItemsLocation] = useState([]);
  const [modal, setModal] = useState(false);
  const [providerID, setProviderID] = useState(null);
  const listItems = useMemo(() => {
    return Array.isArray(ItemLists) ? [...ItemLists] : [];
  }, [ItemLists])
  const [filteredItems, setFilteredItems] = useState(listItems);
  const filteredListItem = useMemo(() => {
    return (ItemLists ?? []).filter(item => item.value !== "All");
  }, [ItemLists]);
  // Initial selection (runs once on mount)
  const [selectedItems, setSelectedItems] = useState(() => {
    return type === 'FeeSetup' && filteredListItem.length > 0
      ? [filteredListItem[0]]
      : [];
  });
  const close = () => {
    setModal(false);
  }
  let providerScheduler = "";
  if (modal) {
    providerScheduler = <ProviderSchedModal isopenProviderSch={modal} isClosed={close} providerID={providerID} Name={Name} />
  }

  const handleItemClick = (item) => {
    if (item.value != -1 && item.value != 'All') {
      // if (view === 'Week' || view === 'Today') {
      //   setSelectedItems([item]);
      // } else {
      const isSelected = selectedItems?.some((selectedItem) => selectedItem?.value === item.value);
      if (isSelected) {
        setSelectedItems(selectedItems?.filter((selectedItem) => selectedItem?.value !== item.value));
      } else {
        // let mergedArray = [...selectedItems, item];
        // setSelectedItems(() => mergedArray);
        setSelectedItems(prev => [...prev, item]);
      }
      // }
    } else {
      if (item.value === "All") {
        if (item.display === 'Select All') {
          let filteredArray = filteredListItem?.filter((DropDownItem) => {

            if (DropDownItem.value === "All") {
              return false
            }
            else {
              let notSelectedValue = !selectedItems.some((selected) => {
                return (DropDownItem.value === selected.value);
              })
              return notSelectedValue
            }

          })

          if (filteredArray.length === 0) {
            setSelectedItems([]);
          } else {
            setSelectedItems(
              [...selectedItems, ...filteredArray]
            );
          }


        }
        else if (item.display === 'Unselect All') {
          setSelectedItems([]);
        }

      }
    }
  };

  const handleItemClickLocation = (item) => {
    if (item.value === "Select All") {
      const actualLocations = AllLocation.filter(loc => loc.value !== "Select All");
      const allSelected = actualLocations.every(loc =>
        selectedItemsLocation.some(sel => sel.value === loc.value)
      );
      if (!allSelected) {
        const updatedLocations = actualLocations.map(loc => ({ ...loc, InActive: 'True' }));
        setSelectedItemsLocation(updatedLocations);
      } else {
        const updatedLocations = actualLocations.map(loc => ({ ...loc, InActive: '' }));
        setSelectedItemsLocation([]);
      }
      return;
    }

    // Baaki normal selection logic
    const isSelected = selectedItemsLocation.some(
      (selectedItem) => selectedItem?.value === item.value
    );
    if (!isSelected) {
      item.InActive = 'True';
      let newList = selectedItemsLocation?.filter((selectedItem) => selectedItem?.value !== item.value);
      setSelectedItemsLocation([...newList, item]);
    } else {
      item.InActive = '';
      let newList = selectedItemsLocation?.filter((selectedItem) => selectedItem?.value !== item.value);
      setSelectedItemsLocation([...newList]);
    }
  };

  const FilterLocationActive = (AllLocation) => {
    setSelectedItemsLocation(AllLocation?.filter(a => a.InActive === 'True' || a.InActive === 'true'));
  }

  const FilteredNonSelectedItems = (outerArray, innerArray) => {
    let filteredArray = outerArray?.filter((DropDownItem) => {
      if (DropDownItem.value === "All") {
        return false
      }
      else {
        let notSelectedValue = !innerArray.some((selected) => {
          return (DropDownItem.value === selected.value);
        })
        return notSelectedValue
      }
    })
    return filteredArray;
  }

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleProviderScheduler = (e, providerID) => {
    if (providerID) {
      setProviderID(providerID);
      setModal(true);
    }
  }

  useEffect(() => {
    FilterLocationActive(AllLocation);
    if (type !== 'provider' && view !== 'day') return;
    const allProviders = filteredListItem.filter(item => item.value !== 'All');
    const alreadyAllSelected = allProviders.every(p =>
      selectedItems.some(s => s.value === p.value)
    ) && selectedItems.length === allProviders.length;

    if (!alreadyAllSelected) {
      setSelectedItems(allProviders);
    }

  }, [])

  useEffect(() => {
    const filteredItemArray = listItems?.filter((item) =>
      item?.display?.toLowerCase().includes(searchQuery?.toLowerCase()) || item?.value === "All"
    );
    setFilteredItems(filteredItemArray);
  }, [searchQuery])

  useEffect(() => {
    if (type === 'provider') {
      // Only run this logic when the view actually changes
      if (prevViewRef.current !== view && view !== 'day') {
        const previousView = prevViewRef.current;
        prevViewRef.current = view;

        // Reset view initialization flag when view changes
        viewInitializedRef.current = false;

        // If switching FROM Week/Today view TO another view where we need multiple selection
        // if ((previousView === 'Week' || previousView === 'Today') &&
        //   (view !== 'Week' && view !== 'Today')) {
        // Keep existing selection if any, otherwise use default
        if (selectedItems.length === 0 && filteredItems?.length > 1) {
          setSelectedItems([filteredItems[1]]);
        }
        // }
        // If switching TO Week/Today view FROM another view
        // else if ((view === 'Week' || view === 'Today') &&
        //   (previousView !== 'Week' && previousView !== 'Today')) {
        //   // If we have multiple selections in Week/Today view, keep only the first one
        //   if (selectedItems.length > 1) {
        //     setSelectedItems([selectedItems[0]]);
        //   }
        //   // If no selection exists, select the first available provider
        //   else if (selectedItems.length === 0 && filteredItems?.length > 0) {
        //     const firstNonAllItem = filteredItems.find(item => item.value !== 'All');
        //     if (firstNonAllItem) {
        //       setSelectedItems([firstNonAllItem]);
        //     }
        //   }
        // }

        // Mark this view as initialized
        viewInitializedRef.current = true;
      }

      // Handle initial load or when ItemLists changes
      if (!viewInitializedRef.current  && view !== 'day') {
        let filteredItemsList = ItemLists || [];

        // if (view === "Week" || view === "Today") {
        //   // Remove "All" option for Week/Today views
        //   filteredItemsList = filteredItemsList.filter((item) => item?.value !== 'All');

        //   if (filteredItemsList?.length >= 1 && selectedItems.length === 0) {
        //     setSelectedItems([filteredItemsList[0]]);
        //   }
        // } else {
        // For other views, include "All" option
        if (filteredItemsList?.length >= 1 && selectedItems.length === 0) {
          // Don't auto-select "All", select the first actual provider
          const firstProvider = filteredItemsList.find(item => item.value !== 'All');
          if (firstProvider) {
            setSelectedItems([firstProvider]);
          }
        }
        // }

        setFilteredItems(filteredItemsList);
        viewInitializedRef.current = true;
      }
    }
  }, [view, ItemLists, type, filteredItems, selectedItems]);

  useEffect(() => {
    if (type === 'FeeSetup' && filteredListItem.length > 0) {
      const firstItem = filteredListItem[0];
      if (!selectedItems.some(item => item.value === firstItem.value)) {
        setSelectedItems([firstItem]);
      }
    }
  }, [filteredListItem]);

  useEffect(() => {
    if (handleSelectedProviders) {
      handleSelectedProviders(selectedItems, "provider");
    }
    if (type === "provider") {
      dispatch(SchedulerProviderArray({ type: 'SchedulerProviderArray', payload: selectedItems }));
      // if (view !== "Week" && view !== "Today") {
      let filteredArray = FilteredNonSelectedItems(filteredItems, selectedItems);
      let array = [...filteredItems];
      if (filteredArray.length === 0) {
        let obj = { value: "All", display: "Unselect All" }
        array.splice(0, 1, obj)
        setFilteredItems(array);
      } else {
        let obj = { value: "All", display: "Select All" }
        array.splice(0, 1, obj);
        setFilteredItems(array);
      }
      // }
    }
  }, [selectedItems])

  useEffect(() => {
    if (Name === 'ProviderSchedler') {
      if (handleSelectedProvidersLocation && selectedItemsLocation?.length != 0) {
        handleSelectedProvidersLocation(selectedItemsLocation, "provider");
      }
    }

  }, [selectedItemsLocation])

  const prevProviderViewModeRef = useRef(providerViewMode);

  useEffect(() => {
    if (type !== 'provider') return;
    // if (prevProviderViewModeRef.current === providerViewMode) return;
    prevProviderViewModeRef.current = providerViewMode;

    if (providerViewMode === 'allProviders') {
      const allProviders = filteredListItem.filter(item => item.value !== 'All');
      const alreadyAllSelected = allProviders.every(p =>
        selectedItems.some(s => s.value === p.value)
      ) && selectedItems.length === allProviders.length;

      if (!alreadyAllSelected) {
        setSelectedItems(allProviders);
      }

    } else if (providerViewMode === 'providerWise') {
      // if (selectedItems.length > 1) {
      //   setSelectedItems([selectedItems[0]]);
      // } else if (selectedItems.length === 0 && filteredListItem.length > 0) {
      //   setSelectedItems([filteredListItem[0]]);
      // }
    }
  }, [providerViewMode]);
  return (
    <div className={`hk-SchedulerList__body ${className}`}>
      {type === 'FeeSetup' ?
        null
        :
        <div className='ar-input position-relative mb-06-px'>
          <input
            type="text"
            className="form-control w-100 border-0 rounded-0"
            name="AllocateAmount"
            id="AllocateAmount"
            variant="outlined"
            placeholder='Search...'
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <i className='icon-Clip-path-group fs-10 position-absolute translate-middle-y top-50'></i>
        </div>
      }
      {providerScheduler}
      {type === 'FeeSetup' && IsHomeCare === 'true' ?
        <div className='hk-SchedulerList__body__list' onClick={() => AddCounty()}>
          <div className='hk-SchedulerList__body__list__item '>
            <div className='d-flex gap-1 align-items-center'>
              <i className='icon-plus-feesetup fs-11'></i>
              <div className='heading fs-12 drk-green-clr'>Add County</div>
            </div>
          </div>
        </div>
        : null
      }
      <div className="hk-SchedulerList__body__list">
        {Name === 'ProviderSchedler' ?
          <>
            {type === 'provider' ?
              <div className='ar-input  position-sticky top-0'>
                <input
                  type="text"
                  className="form-control w-100 border-0 rounded-0"
                  name="AllocateAmount"
                  id="AllocateAmount"
                  variant="outlined"
                  placeholder='Search...'
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <i className='icon-Clip-path-group fs-10 position-absolute translate-middle-y top-50'></i>
              </div>
              :
              null
            }
            {AllLocation?.filter((item) =>
              item.display.toLowerCase().includes(searchQuery.toLowerCase()))
              .map((item) => {
                let isSelected;
                if (item.value === "Select All") {
                  // Agar sab location selected hain to "Select All" ko selected dikhao
                  const actualLocations = AllLocation.filter(loc => loc.value !== "Select All");
                  isSelected = actualLocations.length > 0 && actualLocations.every(loc =>
                    selectedItemsLocation.some(sel => sel.value === loc.value)
                  );
                } else {
                  isSelected = selectedItemsLocation.some(
                    (selectedItem) => selectedItem?.value === item?.value
                  );
                }
                return (
                  <div
                    key={item?.value}
                    className={`hk-SchedulerList__body__list__item ${isSelected ? "selected" : ""}`}
                    onClick={() => handleItemClickLocation(item)}
                  >
                    {isSelected && <i className="icon-check"></i>}
                    <span>{item?.display}</span>
                  </div>
                );
              })}
          </>
          :
          <>
            {filteredItems?.map((item) => (
              <div
                key={item?.value}
                className={`hk-SchedulerList__body__list__item ${selectedItems?.some(
                  (selectedItem) => selectedItem?.value === item?.value
                )
                  ? "selected"
                  : ""
                  }`}
              >
                {selectedItems.some(
                  (selectedItem) => selectedItem?.value === item?.value
                ) && <i className="icon-check"></i>}
                <div className="d-flex w-100 align-items-center justify-content-between arr min-w-0 gap-10">
                  <span className={`validation_message text-nowrap min-w-0 
                    ${item.value === "All" ? 'font-m fs-11 text-uppercase user-select-none sticky-select' : ''}`}
                    onClick={() => handleItemClick(item)}>
                    {item?.display}
                  </span>
                  {(type === 'provider' && item.value !== "All") ?
                    <div className="d-flex align-items-center gap-6">
                      <div class={`ar_chekbox-circle  ${item?.ColorCode}`} style={{ backgroundColor: `${item?.ColorCode}`, margin: '0' }}></div>
                      <i className="icon-file-timer" onClick={(e) => handleProviderScheduler(e, item?.value)}></i>
                    </div>
                    : null}

                  {type === 'FeeSetup' && IsHomeCare === 'true' ?
                    <div className="counry-edit-delte d-flex gap-1 allign-items-center">
                      <i className="icon-edit-pencil fs-11" onClick={() => AddCounty(item)}></i>
                      <i className="icon-delete fs-11 ar-light-color" onClick={() => ConfirmDelete(item)}></i>
                    </div>
                    : null}
                </div>
              </div>
            ))}</>}
      </div>
    </div >
  );
};

export default SearchList;
